<app-banner
    *ngIf="bannerShown"
    text="Your subscription has expired - customers can no longer make bookings. Resume your subscription to continue."
    [buttonTitle]="'Resume Subscription'"
    [type]="'danger'"
    (buttonClicked)="clickResumeSubscription()"
>
</app-banner>
